(function () {
  function kzhEsc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function kzhImg(u, w) { if (!u) return ''; return u.split('?')[0] + '?width=' + w; }
  // Desktop : afficher les variantes de chaque produit du menu, cliquables vers la variante.
  function kzhVariants(root) {
    root.querySelectorAll('.kzh__panel').forEach(function (panel) {
      var seen = {};
      var links = panel.querySelectorAll('a.kzh__prod');
      Array.prototype.forEach.call(links, function (a) {
        if (a.dataset.kzhVarDone) return;
        a.dataset.kzhVarDone = '1';
        var href = a.getAttribute('href'); if (!href) return;
        var base = href.split('?')[0].replace(/\/$/, '');
        if (seen[base]) { a.remove(); return; }
        seen[base] = 1;
        fetch(base + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (p) {
            if (!p || !p.variants || !p.variants.length) return;
            var name = p.title || '';
            var real = p.variants.filter(function (v) { return (v.title || '').toLowerCase() !== 'default title'; });
            if (real.length < 2) return;
            var frag = document.createDocumentFragment();
            real.forEach(function (v) {
              var img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
              var card = document.createElement('a');
              card.className = 'kzh__prod kzh__prod--var';
              card.dataset.kzhVarDone = '1';
              card.href = base + '?variant=' + v.id;
              card.innerHTML = '<span class="kzh__prod-thumb">' + (img ? '<img src="' + kzhEsc(kzhImg(img, 160)) + '" alt="" loading="lazy">' : '') + '</span>' +
                '<span class="kzh__prod-info"><span class="kzh__prod-name">' + kzhEsc(name) + '</span><span class="kzh__prod-sub">' + kzhEsc(v.title) + '</span></span>';
              frag.appendChild(card);
            });
            a.parentNode.replaceChild(frag, a);
          }).catch(function () {});
      });
    });
  }
  // Mobile : dedoublonner les variantes du tiroir si un produit est dans plusieurs slots.
  function kzhDedupeDrawer(root) {
    root.querySelectorAll('.kzh-drawer__body').forEach(function (body) {
      var seen = {};
      body.querySelectorAll('.kzh-drawer__var').forEach(function (a) {
        var href = a.getAttribute('href') || '';
        if (seen[href]) { a.remove(); return; }
        seen[href] = 1;
      });
    });
  }
  // FIX G : listeners globaux (keydown Escape) attaches une seule fois au niveau module.
  // Les init() enregistrent leurs handlers de fermeture; un seul vrai listener global les appelle.
  var kzhEscCbs = [], kzhGlobalBound = false;
  function kzhOnEscape(fn) { kzhEscCbs.push(fn); }
  function kzhBindGlobal() {
    if (kzhGlobalBound) return;
    kzhGlobalBound = true;
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { for (var i = 0; i < kzhEscCbs.length; i++) kzhEscCbs[i](); }
    });
  }
  function init(root) {
    if (!root || root.dataset.kzhInit) return;
    root.dataset.kzhInit = '1';
    var burger = root.querySelector('[data-kzh-burger]');
    var drawer = root.querySelector('[data-kzh-drawer]');
    var closeBtn = root.querySelector('[data-kzh-close]');
    var modal = root.querySelector('[data-kzh-loc-modal]');
    // FIX F : verrou de scroll via classe kzc-lock sur <html> (au lieu de style.overflow inline),
    // ne modifie que header.js.
    function openDrawer() { if (drawer) drawer.classList.add('is-open'); document.documentElement.classList.add('kzc-lock'); }
    function closeDrawer() { if (drawer) drawer.classList.remove('is-open'); document.documentElement.classList.remove('kzc-lock'); }
    function closeModal() { if (modal) modal.classList.remove('is-open'); }
    if (burger) burger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (drawer) drawer.addEventListener('click', function (e) { if (e.target === drawer) closeDrawer(); });
    // FIX G : au lieu d'un document.addEventListener('keydown') par init, on enregistre le callback
    // aupres du listener global unique.
    kzhOnEscape(function () { closeDrawer(); closeModal(); });
    root.querySelectorAll('[data-kzh-loc-open]').forEach(function (b) {
      b.addEventListener('click', function () { if (modal) modal.classList.add('is-open'); closeDrawer(); });
    });
    var locClose = root.querySelector('[data-kzh-loc-close]');
    if (locClose) locClose.addEventListener('click', closeModal);
    if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    var sel = root.querySelector('[data-kzh-loc-select]');
    if (sel) {
      var toggle = sel.querySelector('[data-kzh-loc-toggle]');
      var input = root.querySelector('[data-kzh-country-input]');
      var curFlag = sel.querySelector('[data-kzh-current-flag]');
      var curLabel = sel.querySelector('[data-kzh-current-label]');
      var search = sel.querySelector('[data-kzh-loc-search]');
      if (toggle) toggle.addEventListener('click', function () { sel.classList.toggle('is-open'); if (sel.classList.contains('is-open') && search) search.focus(); });
      sel.querySelectorAll('.kzh-loc-option').forEach(function (opt) {
        opt.addEventListener('click', function () {
          if (input) input.value = opt.dataset.iso;
          if (curLabel) curLabel.textContent = opt.dataset.label;
          if (curFlag) curFlag.src = opt.dataset.flag;
          sel.querySelectorAll('.kzh-loc-option').forEach(function (o) { o.classList.remove('is-active'); });
          opt.classList.add('is-active');
          sel.classList.remove('is-open');
        });
      });
      if (search) search.addEventListener('input', function () {
        var q = search.value.toLowerCase();
        sel.querySelectorAll('.kzh-loc-option').forEach(function (o) {
          var li = o.closest('li');
          if (li) li.style.display = (o.dataset.search || '').indexOf(q) > -1 ? '' : 'none';
        });
      });
      if (modal) modal.addEventListener('click', function (e) { if (!e.target.closest('[data-kzh-loc-select]')) sel.classList.remove('is-open'); });
    }
    root.querySelectorAll('[data-kzh-item]').forEach(function (item) {
      var title = item.querySelector('[data-kzh-title]');
      if (!title) return;
      title.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: hover)').matches) return;
        if (title.tagName === 'A' && !item.classList.contains('is-open')) e.preventDefault();
        var wasOpen = item.classList.contains('is-open');
        root.querySelectorAll('[data-kzh-item]').forEach(function (i) { i.classList.remove('is-open'); });
        if (!wasOpen) item.classList.add('is-open');
      });
    });
    // FIX D : le fetch des variantes du mega-menu n'est plus lance au chargement.
    // Il est differe au 1er mouseenter/focusin sur le header, et memoise (une seule fois).
    var kzhVariantsDone = false;
    function kzhVariantsOnce() {
      if (kzhVariantsDone) return;
      kzhVariantsDone = true;
      kzhVariants(root);
    }
    root.addEventListener('mouseenter', kzhVariantsOnce, true);
    root.addEventListener('focusin', kzhVariantsOnce);
    kzhDedupeDrawer(root);
  }
  function boot() { kzhBindGlobal(); document.querySelectorAll('[data-kzh]').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
